import UserManagementActionCreator from '../actions/UserManagementActionCreator';
import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import InternetBankingActions from '../actions/InternetBankingActions';

const _getUserDetailsEndpoint = '/ibapi/v2/user/details';

export default class UserManagementApiUtils {
  static getUserDetails() {
    let url = `${envConfig.apiBaseUrlPAAS}${_getUserDetailsEndpoint}`;
    if (envConfig.isStubsEnabled) {
      url = `${envConfig.apiBaseUrlStub}${_getUserDetailsEndpoint}`;
    }
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.userServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body) => {
        UserManagementActionCreator.handleUserDetailsSuccess(body);
      },
      (error) => {
        UserManagementActionCreator.handleUserDetailsError(error);
        InternetBankingActions.navigateToWebTask('WEB-ERROR-PAGE');
      }
    );
  }
}
